module.exports = __webpack_public_path__ + "img/FR12933.4c55e2da.png";